export default `+mod(atan(p.y,p.x),2.*M_PI/n)-M_PI/n)
  #define fold(p,v)p-2.*min(0.,dot(p,v))*v;

  float de( vec3 p ){
    float s = 1.0;
    p.z=fract(p.z)-.5;
    for(int i=0;i<20;i++){ 
      p.y += .15;
      p.xz = abs(p.xz);
      for(int j=0;j<2;j++){
        p.xy = pmod(p.xy,8.);
        p.y -= .18;
      }
      p.xy = fold(p.xy,normalize(vec2(1.0,-.8)));
      p.y = -abs(p.y);
      p.y += .4;
      p.yz = fold(p.yz,normalize(vec2(3.0,-1.0)));
      p.x -= .47;
      p.yz = fold(p.yz,normalize(vec2(2.0,-7.0)));
      p -= vec3(1.7,.4,0.0);
      float r2= 3.58/dot(p,p);
      p *= r2;
      p += vec3(1.8,.7,.0);
      s *= r2;
    }
    return length(p)/s;
  }`